export default __webpack_public_path__ + "static/media/A_05_05_Grafik_v01.0287b37a.png";